import React from 'react';
import { ItemOption } from "./ItemOption.js";
import { isFolderItem } from "../../functions/isFolderItem.js";
import { FolderButton } from "../FolderButton/FolderButton.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ItemDisabled({
  item,
  previousFolderLabel
}) {
  return isFolderItem(item) ? /*#__PURE__*/_jsx(FolderButton, {
    folderItem: item,
    buttonProps: {
      'aria-disabled': true
    }
  }) : /*#__PURE__*/_jsx(ItemOption, {
    item: item,
    previousFolderLabel: previousFolderLabel,
    selected: false,
    buttonProps: {
      disabled: true
    }
  });
}